export default __webpack_public_path__ + "static/media/image-batch-collection.1063db06.png";